import { connect } from 'react-redux';
import View from './RetirementWorkflowView';
import { WORKFLOW_ID } from './RetirementWorkflowConstants';
import {
  endOfWorkflowsRedirectTo,
  reloadAdvizrApplication,
} from '../AdvWorkflow/AdvWorkflowHelpers';
import { shouldSkipSummarySelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { GoalTypeDTO } from '../../FinancialPlanOPL/types/goalsDTO';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';

const mapStateToProps = (state, ownProps) => ({
  workflowId: WORKFLOW_ID,
  shouldSkipSummary: shouldSkipSummarySelector(state, ownProps),
});

const mapDispatchToProps = () => ({
  outputFunction: clientId => response => {
    const { ADV } = window;
    reloadAdvizrApplication(true, false, () => {
      const currentClient = ADV.util.getCurrentClient(ADV.data);

      const outputRoute = currentClient.ComponentName || getGoalPageName(GoalTypeDTO.Retirement);

      const params = {
        clientId,
        goalId: response.payload.viewData.Goal.Id,
      };
      endOfWorkflowsRedirectTo(outputRoute, params);
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
